import styled from 'styled-components';

const PageContainer = styled.div`
`;

export const PhoneBookPage = () => {
  return (
	<PageContainer />
  );
};

export default PhoneBookPage;
